var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleArrow = function SvgDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.884 6.42L3.41 4.004l.707-.69L7.298 6.42 4.116 9.527l-.707-.69L5.884 6.42z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.329 6.42L5.854 4.004l.707-.69L9.743 6.42 6.561 9.527l-.707-.69L8.329 6.42z"
  })));
};
export default SvgDoubleArrow;